module.exports = __webpack_public_path__ + "img/TRIG-alt.a585464e.svg";